import { getMessages } from '../../../../../../../store/constants';

export const ADD_TO_MY_WORK_TOOLTIP_REMOVE = getMessages().getText('card_form_action_add_to_my_work_tooltip_remove');
export const ADD_TO_MY_WORK_TOOLTIP_ADD = getMessages().getText('card_form_action_add_to_my_work_tooltip_add');
export const ADD_TO_MY_WORK_SNACKBAR_ADD = getMessages().getText('card_form_action_add_to_my_work_snackbar_add');
export const ADD_TO_MY_WORK_SNACKBAR_REMOVE = getMessages().getText('card_form_action_add_to_my_work_snackbar_remove');
